import readline from "node:readline";
import { api } from "../lib/api.js";

interface App {
  name: string;
}

export async function rmCommand(appId: string): Promise<void> {
  const res = await api.get(`/v1/apps/${appId}`);
  if (!res.ok) {
    console.error("App not found.");
    process.exit(1);
  }

  const app = (await res.json()) as App;

  const confirmed = await new Promise<boolean>((resolve) => {
    const rl = readline.createInterface({
      input: process.stdin,
      output: process.stdout,
    });
    rl.question(`Delete ${app.name}? (y/N) `, (answer) => {
      rl.close();
      resolve(answer.toLowerCase() === "y");
    });
  });

  if (!confirmed) {
    console.log("Cancelled.");
    return;
  }

  const delRes = await api.del(`/v1/apps/${appId}`);
  if (!delRes.ok) {
    console.error("Failed to delete app.");
    process.exit(1);
  }

  console.log(`Deleted ${app.name}`);
}
